import { TYPES } from 'action-types/cbl';
import {
    ICblDetail, EmptyCblDetail
} from './models';

interface IAction {
    readonly type: string;
    readonly details: ICblDetail;
    readonly response: any;
    readonly errors: string;
}
export interface ICblState {
    readonly isFetchDataLoading: boolean;
    readonly isFetchDataError: boolean;
    readonly detailsPendingError: string;
    readonly details: any;
    readonly response: any
}

export const defaultState: ICblState = {
    isFetchDataLoading: false,
    isFetchDataError: false,
    detailsPendingError: '',
    details: EmptyCblDetail,
    response: {
        pageNumber: 1,
        page: 1,
        pageSize: 0,
        result: [],
        totalCount: 0
    }
}

export const reducer = (state: ICblState = defaultState, action: IAction): ICblState => {
    switch (action.type) {
        case TYPES.CBL_DETAILS.PENDING:
            return {
                ...state,
                isFetchDataError: false,
                isFetchDataLoading: true,
                detailsPendingError: '',
                details: defaultState.details
            };
        case TYPES.CBL_DETAILS.FULFILLED:
            return {
                ...state,
                isFetchDataLoading: false,
                details: action.details || defaultState.details
            };
        case TYPES.CBL_DETAILS.REJECTED:
            return {
                ...state,
                isFetchDataError: true,
                isFetchDataLoading: false,
                detailsPendingError: action.errors
            };
        case TYPES.CBL_DETAILS.RESET_ERROR:
            return {
                ...state,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };
        case TYPES.RESET_CBL.PENDING:
            return {
                ...state,
                isFetchDataError: false,
                detailsPendingError: ''
            };
        case TYPES.RESET_CBL.FULFILLED:
            return {
                ...state,
                response: action.response && action.response.length === 0 ?  defaultState.response: action.response
            };
        case TYPES.RESET_CBL_DETAILS:
            return {
                ...state,
                details: defaultState.details,
            }
        case TYPES.SEARCH_CBL.PENDING:
            return {
                ...state,
                isFetchDataLoading: true,
                isFetchDataError: false,
                detailsPendingError: ''
            };
        case TYPES.SEARCH_CBL.FULFILLED:
            return {
                ...state,
                isFetchDataLoading: false,
                response: action.response || defaultState.response
            };
        case TYPES.SEARCH_CBL.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };
        case TYPES.SEARCH_CBL.RESET_ERROR:
            return {
                ...state,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };
        default:
            return state;
    }
};
